// ============================================================
// Lead magnet config — single source of truth for the opt-in.
// Drop the final PDF file into /app/frontend/public/ and update
// LEAD_MAGNET_FILE below to point to it (e.g. "/better-rest-blueprint.pdf").
// ============================================================

export const LEAD_MAGNET_FILE = "/better-rest-blueprint.pdf";
export const LEAD_MAGNET_FILENAME = "Better-Rest-Blueprint.pdf";
